// libs
import React from 'react';
import { styled } from '@nykaa/ui-components';

// constants
import { TAB_INDEX } from 'shared/constants';
import { DEFAULT_STORE } from 'shared/helpers/storeUrl';

interface StoreToggleProps {
  currentStoreId: string;
  option1StoreId: string;
  option2StoreId: string;
  toggleImage1: string;
  toggleImage2: string;
  option1AriaLabel: string;
  option2AriaLabel: string;
}

const ToggleImage = styled.img`
  cursor: pointer;
  height: 48px;
  display: block;
  transition: opacity 0.2s ease;
  margin-left: ${({ theme }) => theme.spacing.spacing80};
  &:hover {
    opacity: 0.85;
  }
`;

function StoreToggle({
  currentStoreId,
  option1StoreId,
  option2StoreId,
  toggleImage1,
  toggleImage2,
  option1AriaLabel,
  option2AriaLabel,
}: StoreToggleProps) {
  const handleToggleClick = () => {
    const targetStoreId = currentStoreId === option1StoreId ? option2StoreId : option1StoreId;
    const redirectUrl = targetStoreId === DEFAULT_STORE ? '/' : `/${targetStoreId}`;

    // Set flag in sessionStorage to indicate store was switched
    sessionStorage.setItem('store_switched_via_toggle', targetStoreId);
    sessionStorage.setItem('store_toggle_source', 'header_toggle');

    window.location.href = redirectUrl;
  };

  const currentImage = currentStoreId === option1StoreId ? toggleImage1 : toggleImage2;
  const currentAriaLabel = currentStoreId === option1StoreId ? option1AriaLabel : option2AriaLabel;

  return (
    <ToggleImage
      src={currentImage}
      alt={currentAriaLabel}
      aria-label={currentAriaLabel}
      onClick={handleToggleClick}
      role="button"
      tabIndex={TAB_INDEX.ACTION_INVISIBILITY}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggleClick();
        }
      }}
    />
  );
}

export default StoreToggle;
